/*
 * Copyright (c) 2023 Bluemate B.V.
 */

import {FetchMethod} from '@dvrd/dvr-controls';

export const URLS = {
    [FetchMethod.GET]: {
        USER: 'user',
        LOGOUT: 'auth/logout',
        GENERATE_TWO_FACTOR: '2fa/generate',
        DOWNLOAD_INVOICE: 'invoice/download/{account_id}/{invoice_id}',
        QR_CODE_GENERATE: 'qr-code/generate/{account_id}/{product_id}',
        QR_CODE_GENERATE_ALL: 'qr-code/generate-all/{account_id}',
        SEND_INVOICE: 'invoice/send/{account_id}/{invoice_id}',
        ACCOUNT_STATUS: 'account/status/{account_id}',
        INVOICE_HISTORY: 'invoice/history/{account_id}/{invoice_id}',
        CONNECTIONS: 'connections',
        TEST_CONNECTION: 'connection/{name}',
        ADMIN_LOGIN: 'admin/login/{user_id}',
        THREADS: 'threads',
        STOP_THREAD: 'thread/stop/{thread_id}',
        FINISH_THREAD: 'thread/finish/{thread_id}',
        SYSTEM_SERVICES: 'system-service/list',
        GET_INVOICE: 'get-invoice/{account_id}/{invoice_id}',
        GET_EMAIL_STEP_STATS_TOTAL: 'email-step/total-stats/{account_id}/{email_step_id}',
        GET_EMAIL_TEMPLATE: 'get-email-template/{account_id}/{template_id}',
        CREATE_PRODUCTS_IMPORT: 'products/import/{account_id}',
        GET_ACCOUNT: 'account/get/{account_id}',
        SETUP_INTENT: 'setup-intent/{account_id}',
        SUBSCRIPTION_USAGE: 'subscription-usage/{account_id}',
        API_KEYS: 'api-keys/{account_id}',
        IMPORTING_PRODUCTS: 'products/importing/{account_id}',
        DEFAULT_VATS: 'default-vats/{account_id}',
        ADMIN_EMAIL_STEPS: 'admin/email-steps/{user_id}/{account_id}',
        GET_SYSTEM_MESSAGES: 'system-message/get',
        SUBSCRIPTION: 'subscription/{account_id}',
        EMAILS_ENABLED: 'email-steps/enabled/{account_id}',
        CREDIT_EMAIL_STEP: 'credit-invoice/email-step/{account_id}',
        CANCEL_EMAILS: 'invoice/cancel-emails/{account_id}/{invoice_id}',
        SUBSCRIPTION_STATS: 'admin/sub-stats',
        DUPLICATE_TEMPLATE: 'email-template/duplicate/{account_id}/{template_id}',
        ADMIN_ACCOUNTS: 'admin/accounts/{user_id}',
        PROCESS_STATUS: 'process-status/get/{account_id}/{process_id}',
        PROCESS_STATUS_BY_TYPE: 'process-status/by-type/{account_id}/{process_type}',
        ALL_PROCESS_STATUS_BY_TYPE: 'process-status/all-by-type/{process_type}',
        DOWNLOAD_BOL_INVOICE: 'bol-factuur/{file_type}/{account_id}/{invoice_id}',
        ADD_MISSING_PRODUCTS: 'process-status/missing-products/{account_id}/{process_id}',
        RESET_TWO_FACTOR: 'two-factor/reset/{token}',
        UNSUBSCRIBE_MONTHLY_MAIL: 'unsubscribe-monthly/{user_id}',
        INVOICE_STATS: 'invoice-stats/{account_id}',
        SEND_HISTORY_EMAIL: 'email-steps/history/{account_id}',
        INVOICE_REQUEST_STATS: 'invoice-request/stats/{account_id}',
        OPEN_REQUEST_COUNT: 'invoice-request/open-count/{account_id}',
        SEND_FAILED_PAYMENT: 'failed-payment/send/{failed_payment_id}/{user_id}',
        DISCOUNT_ON_CANCEL: 'discount-cancel/{account_id}',
        GET_REVIEW_PRODUCT: 'reviews/product/{account_id}/{ean}',
        GET_REVIEW_TOTALS: 'review/totals',
        GET_PRODUCT_COSTS: 'product-costs/get/{account_id}/{ean}/{fulfilment}',
        GET_RATING_EXPORTS: 'ratings/export-processes/{account_id}/{ean}',
        DOWNLOAD_RATING_EXPORT: 'ratings/download-export/{account_id}/{file_id}',
        USERS_ESTIMATE: 'active-estimate',
        GLOBAL_EMAIL_STATS: 'email-step/global-stats/{account_id}',
        CHECK_INVITATION: 'invitation/check/{id}',
        USER_HAS_SUBSCRIPTION: 'user/has-subscription',
        PRODUCTS_COUNT: 'products/count/{account_id}',
        ACCOUNT_RATING_COUNTS: 'reviews/account-rating-counts/{account_id}',
        GET_SUBSCRIPTION_CUSTOMER: 'subscription/customer/{account_id}',
        GET_SUBSCRIPTION_TAX_IDS: 'subscription/tax-ids/{account_id}',
        GET_DEFAULT_EMAIL_TEMPLATE: 'default-email/get/{id}',
        ADMIN_EMAIL_INFO: 'admin/email-info/{id}',
        GET_NOTIFICATIONS: 'notification/all/{account_id}',
        GET_SUBSCRIPTION_MODULES: 'subscription-module/all/{account_id}',
        HAS_ACTIVE_SUBSCRIPTION_MODULE: 'subscription-module/has-active/{account_id}/{name}',
        GET_PLANNED_EMAILS_COUNT: 'email-steps/planned-count/{account_id}',
        HAS_PLANNED_EMAILS: 'planned-emails/exists/{account_id}',
        GET_NOTIFICATION_ACCOUNTS: 'notification/get-accounts',
        EXPORT_PRODUCTS: 'export-vats/{account_id}',
        GET_PEPPOL_INVOICE_COUNTS: 'peppol/invoice-counts/{account_id}',
        GET_PEPPOL_ENABLED: 'peppol/enabled/{account_id}',
        GET_EMAIL_STEP: 'email-step/get/{account_id}/{email_step_id}',
        VALIDATE_EMAIL_STEPS: 'email-steps/validate/{account_id}',
        GET_ANALYTICS_SETTINGS: 'analytics/settings',
        GET_PRODUCT_DIMENSIONS: 'products/dimensions/{account_id}/{ean}',
        GET_OPEN_PRODUCT: 'open-product/{account_id}/{ean}',
        GET_PRODUCT_BY_EAN: 'product/get-by-ean/{account_id}/{ean}',
        GET_MANUAL_KEYWORDS_COUNT: 'search-rankings/manual-keyword-count/{account_id}',
        // Phase 5 web push.
        LIST_DEVICE_TOKENS: 'device-token/list',
        MAIL_REDIRECT_INFO: 'notification/mail-redirect',
        GET_BOL_OAUTH_CLIENT: 'bol-oauth/get-client',
        EXPORT_PRODUCT_COSTS_V2: 'product-costs-v2/export/{account_id}'
    },
    [FetchMethod.POST]: {
        LOGIN: 'auth/login',
        VALIDATE_TWO_FACTOR: '2fa/validate',
        DISABLE_TWO_FACTOR: '2fa/disable',
        REGISTER: 'auth/register',
        CREATE_TEMPLATE: 'template/create',
        CREATE_ACCOUNT: 'account/create',
        GOOGLE_LOGIN: 'auth/google/login',
        GOOGLE_REGISTER: 'auth/google/register',
        GET_ATTACHMENTS: 'attachments/get',
        FIND_ATTACHMENTS: 'attachments/find',
        GET_EMAIL_TEMPLATES: 'email-templates',
        CREATE_EMAIL_TEMPLATE: 'email-template/create',
        TEST_EMAIL_TEMPLATE: 'email-template/test',
        GET_MINIMAL_INVOICES: 'minimal-invoices',
        ORDER_CARD_DETAILS: 'order-card-details',
        PREVIEW_TEMPLATE: 'template/preview/{account_id}',
        GET_USERS: 'admin/users',
        DOWNLOAD_INVOICES: 'invoices/download',
        SEND_INVOICES: 'invoices/send',
        RESET_PASSWORD: 'reset-password',
        GET_BOL_PRODUCTS: 'products/get/{account_id}',
        GET_BOL_PRODUCTS_V2: 'products/v2/get',
        GET_BOL_PRODUCTS_SELECTION: 'products/get-selection',
        GET_PRODUCT_IMAGES: 'products/get-images',
        STRIPE_PORTAL: 'stripe-portal',
        CHECKOUT: 'checkout',
        CREDIT_INVOICE: 'credit-invoice/create',
        EXPORT_INVOICES: 'invoices/export',
        GET_INVOICE_EXPORT_COUNT: 'invoices/export-count',
        EXPORT_PROCESS_DOWNLOAD: 'export-process/download',
        UPLOAD_ATTACHMENT: 'attachment/upload/{account_id}',
        DELETE_ATTACHMENT: 'attachment/delete',
        CREATE_EMAIL_STEP: 'email-step/create',
        BULK_SEQUENCE: 'invoices/bulk-sequence',
        GET_SUBSCRIPTION_STATS: 'subscription-stats',
        CREATE_SYSTEM_MESSAGE: 'system-message/create',
        EMAIL_STEP_STATS: 'email-step/stats',
        CREATE_REVERSE_CHARGE: 'reverse-charge/create',
        SET_CANCEL_REASON: 'cancel-reason',
        GET_BOL_RETURNS: 'return/all',
        CREDIT_RETURNS: 'return/credit',
        RETURN_COUNTS: 'return/counts',
        VAT_DECLARATION: 'btw-aangifte/berekenen',
        SET_BETA_DECISION: 'beta-decision',
        AUTHORIZE_BOL_OAUTH: 'bol-oauth/authorize',
        OAUTH_AUTHORIZE: 'oauth/authorize',
        GENERATE_TWO_FACTOR_RESET: 'two-factor-reset/generate',
        EXPORT_VAT_DECLARATION: 'btw-aangifte/export',
        EXPORT_PROCESSES: 'export-process/all',
        SET_VAT_NUMBER: 'user/vat-number',
        SEND_INVOICE_CONFIGURED: 'invoice/send-configured',
        IMPORT_HISTORY: 'admin/import-history',
        ADMIN_EMAIL_SEQUENCE: 'admin/email-sequence',
        GET_EMAIL_SEQUENCE_COUNT: 'admin/email-sequence-count',
        IMPORT_VATS: 'import-vats',
        GET_LATEST_INVOICE_NUM: 'invoice-number/latest',
        PLAN_HISTORY_IMPORT: 'planned/add-history-import',
        GET_INVOICE_REQUESTS: 'invoice-request/all',
        UPLOAD_INVOICE: 'invoice-request/upload',
        UPLOAD_MULTIPLE_INVOICES: 'invoice-request/upload-multiple',
        COPY_PDF_TEMPLATE: 'pdf-template/copy',
        COPY_EMAIL_STEPS: 'email-steps/copy',
        APPLY_COUPON: 'apply-coupon',
        GET_FAILED_PAYMENTS: 'failed-payment/all',
        ADMIN_GENERATE_NEW_INVOICE: 'failed-payment/admin/generate',
        GENERATE_NEW_INVOICE: 'failed-payment/generate',
        PRODUCT_REVIEW_COUNTS: 'product-review-counts',
        PRODUCT_REVIEWS: 'product-reviews',
        GET_REVIEW_PRODUCTS: 'reviews/products',
        REVIEW_FEED: 'reviews/feed',
        ARCHIVE_INVOICE_REQUEST: 'invoice-request/archive',
        GET_REVIEW_CHART_STATS: 'review-chart-stats',
        GET_REVIEW_CHART_DATA: 'review/chart-data',
        GET_SALES_DASHBOARD_PRODUCTS: 'sales-dashboard/products/{account_id}',
        GET_SALES_DASHBOARD_STATS: 'sales-dashboard/stats/{account_id}',
        GET_SALES_DASHBOARD_CHART_DATA: 'sales-dashboard/chart-data/{account_id}',
        GET_SALES_DASHBOARD_V2_PRODUCTS: 'sales-dashboard-v2/products',
        EXPORT_SALES_DASHBOARD_V2: 'sales-dashboard-v2/export',
        GET_SALES_DASHBOARD_V2_PRODUCT: 'sales-dashboard-v2/get-product',
        SET_PRODUCT_COSTS: 'product-costs/set',
        EXPORT_RATINGS: 'ratings/export',
        SELECT_USERS: 'user_selection/select',
        EXPORT_USERS: 'user_selection/export',
        GET_SEARCH_VOLUMES: 'search-volumes/get',
        SEARCH_VOLUMES_AI: 'search-volumes/ai-analysis',
        EXPORT_SALES_DASHBOARD: 'sales-dashboard/export',
        OVERVIEW_TOP_STATS_GENERAL: 'overview/top-stats/general',
        OVERVIEW_TOP_STATS_PROFIT: 'overview/top-stats/profit',
        OVERVIEW_TOP_STATS_ADS: 'overview/top-stats/ads',
        OVERVIEW_PRODUCTS: 'overview/products',
        OVERVIEW_RETURNS: 'overview/returns',
        OVERVIEW_REVIEWS: 'overview/reviews',
        OVERVIEW_BUY_BOX: 'overview/buy-box',
        OVERVIEW_STOCK: 'overview/stock',
        OVERVIEW_AD_REVENUE: 'overview/ad-revenue',
        GET_CHURN: 'admin/churn',
        GET_EMAIL_STEPS: 'email-step/all',
        GLOBAL_EMAIL_PERIOD_STATS: 'email-step/global-period-stats',
        LINK_EMAIL_PRODUCTS: 'email-steps/link-products',
        GET_ACCOUNT_USERS: 'account-user/all',
        GET_INVITATIONS: 'invitation/all',
        SEND_INVITATION: 'invitation/send',
        INVITE_ACCOUNT_USER: 'account-user/invite',
        EMAIL_EXISTS: 'user/email-exists',
        CREATE_SUBSCRIPTION_EXISTING_USER: 'subscription/existing-user',
        REFER_A_FRIEND: 'user/refer-friend',
        ADD_TAX_ID: 'subscription/add-tax-id',
        CREATE_DEFAULT_TEMPLATE: 'default-email/create',
        ADMIN_GET_DEFAULT_EMAIL_TEMPLATES: 'default-email/admin-all',
        GET_DEFAULT_EMAIL_TEMPLATES: 'default-email/all',
        TEST_DEFAULT_EMAIL: 'default-email/test',
        INVOICE_REQUEST_SET_INVOICE: 'invoice-request/set-invoice',
        ANALYSE_PRODUCT_REVIEWS: 'reviews/analyse-product',
        CREATE_NOTIFICATION: 'notification/create',
        ADD_SUBSCRIPTION_MODULE: 'subscription-module/add',
        IMPORT_PRODUCTS_ASYNC: 'products/async',
        SEND_TEST_NOTIFICATION: 'notification/test-mail',
        GET_SELECTABLE_REVIEW_PRODUCTS: 'review/selectable-products',
        SUBMIT_NOTIFICATION_FEEDBACK: 'notification/feedback',
        GET_PEPPOL_INVOICES: 'peppol/invoices',
        SEND_PEPPOL_INVOICE: 'peppol/send-invoice',
        TOGGLE_PEPPOL_ENABLED: 'peppol/toggle',
        VERIFY_IP: 'auth/verify-ip',
        ADMIN_GENERATE_VERIFICATION: 'admin/generate-verification',
        GET_PLATFORM_USAGE: 'admin/platform-usage',
        TRACK_ANALYTICS_EVENT: 'analytics/event',
        RUN_ANALYTICS_AGGREGATION: 'analytics/run-aggregation',
        GET_PRODUCT_COSTS_V2: 'product-costs-v2/get-costs',
        CREATE_PRODUCT_COSTS_V2: 'product-costs-v2/create',
        GET_SALES_DASHBOARD_STATS_V2: 'sales-dashboard-v2/stats',
        GET_SEARCH_RANKING_PRODUCTS: 'search-rankings/products/{account_id}',
        GET_SEARCH_RANKING_STATS: 'search-rankings/stats/{account_id}',
        GET_SEARCH_RANKING_PRODUCT_KEYWORDS: 'search-rankings/product-keywords',
        GET_SEARCH_RANKING_KEYWORD_TREND: 'search-rankings/keyword-trend',
        ADD_SEARCH_RANKING_KEYWORD: 'search-rankings/keyword/add',
        BULK_IMPORT_KEYWORDS: 'search-rankings/keyword/bulk-import',
        SAVE_SEARCH_RANKING_COLUMNS: 'search-rankings/columns/save',
        GET_SEARCH_RANKING_COLUMNS: 'search-rankings/columns/get',
        GET_SEARCH_RANKING_PRODUCT_CATEGORIES: 'search-rankings/product-categories',
        GET_SEARCH_RANKING_BUYBOX_TREND: 'search-rankings/buybox-trend',
        GET_SEARCH_RANKING_CATEGORY_TREND: 'search-rankings/category-trend',
        EXPORT_SEARCH_RANKINGS: 'search-rankings/export',
        GET_SUGGESTED_KEYWORDS: 'search-rankings/suggested-keywords',
        // Phase 5 web push.
        REGISTER_DEVICE_TOKEN: 'device-token/register',
        // One removal endpoint — body carries token_id (device panel) or endpoint
        // (a browser cleaning up its own subscription).
        REMOVE_DEVICE_TOKEN: 'device-token/remove',
        SEND_TEST_PUSH: 'notification/test-push',
        SEND_TEST_PUSH_DEVICE: 'device-token/{token_id}/test-push',
        SEND_TEST_MAIL_RECIPIENT: 'notification/test-mail-recipient',
        SUBMIT_FEEDBACK: 'submit-feedback',
        UPLOAD_PRODUCT_COSTS_V2: 'product-costs-v2/import'
    },
    [FetchMethod.PUT]: {
        UPDATE_DEVICE_TOKEN: 'device-token/{token_id}',
        UPDATE_USER: 'user/update',
        UPDATE_TEMPLATE: 'template/update',
        UPDATE_ACCOUNT: 'account/update',
        UPDATE_INVOICE: 'invoice/update',
        UPDATE_EMAIL_TEMPLATE: 'email-template/update',
        UPDATE_ADMIN_USER: 'admin/update-user/{user_id}',
        UPDATE_ADMIN_ACCOUNT: 'admin/update-account/{user_id}',
        TOGGLE_SERVICE: 'system_service/toggle',
        CHANGE_PASSWORD: 'user/password',
        ACTIVATE_API_KEY: 'api-key/activate',
        CREDIT_INVOICE: 'credit-invoice/update',
        UPDATE_EMAIL_STEP: 'email-step/update',
        UPDATE_SYSTEM_MESSAGE: 'system-message/update',
        INVOICE_NUMBER: 'invoice/invoice-number',
        UPDATE_CREDIT_SETTINGS: 'credit-invoice/settings',
        UPDATE_PROCESS_STATUS: 'process-status/update',
        TOGGLE_ALL_SERVICES: 'system-service/toggle-all',
        UPDATE_ACCOUNT_USER: 'account-user/update',
        UPDATE_INVITATION: 'invitation/update',
        UPDATE_CUSTOMER: 'subscription/update-customer',
        UPDATE_DEFAULT_EMAIL_TEMPLATE: 'default-email/update',
        UPDATE_DEFAULT_VATS: 'vat/update-defaults',
        UPDATE_BOL_PRODUCT: 'bol-product/update',
        UPDATE_NOTIFICATION: 'notification/update',
        UPDATE_API_KEY: 'api-key/update',
        TOGGLE_ANALYTICS_COLLECTION: 'analytics/toggle-collection',
        UPDATE_ANALYTICS_SETTINGS: 'analytics/settings',
        ADMIN_TOGGLE_MAINTENANCE: 'admin/toggle-maintenance',
        UPDATE_PRODUCT_COSTS_V2: 'product-costs-v2/update',
        ARCHIVE_SEARCH_RANKING_KEYWORD: 'search-rankings/keyword/archive',
        ARCHIVE_SEARCH_RANKINGS_CATEGORY: 'search-rankings/archive-category'
    },
    [FetchMethod.DELETE]: {
        DELETE_USER: 'user/delete',
        DELETE_ACCOUNT: 'account/{account_id}',
        DELETE_ADMIN_USER: 'admin/delete-user/{user_id}',
        DELETE_ADMIN_ACCOUNT: 'admin/delete-account/{user_id}/{account_id}',
        DELETE_EMAIL_STEP: 'email-step/delete/{account_id}/{email_step_id}',
        DELETE_SYSTEM_MESSAGE: 'system-message/delete/{message_id}',
        DELETE_EMAIL_TEMPLATE: 'email-template/delete/{account_id}/{template_id}',
        DELETE_PROCESS_STATUS: 'process-status/delete/{account_id}/{process_id}',
        DELETE_FAILED_PAYMENT: 'failed-payment/delete/{failed_payment_id}/{user_id}',
        DELETE_PRODUCT_COSTS: 'product_costs/delete/{account_id}/{costs_id}',
        DELETE_RATINGS_EXPORT: 'ratings/delete-export/{account_id}/{process_id}',
        DEACTIVATE_API_KEY: 'api-key/deactivate/{account_id}/{api_key_id}',
        REVOKE_ACCOUNT_USER: 'account-user/revoke/{account_id}/{user_id}',
        DELETE_INVITATION: 'invitation/delete/{account_id}/{invitation_id}',
        DELETE_TAX_ID: 'subscription/delete-tax-id/{account_id}/{tax_id}',
        DELETE_DEFAULT_EMAIL_TEMPLATE: 'default-email/delete/{id}',
        DELETE_NOTIFICATION: 'notification/delete/{account_id}/{notification_id}',
        CANCEL_SUBSCRIPTION_MODULE: 'subscription-module/cancel/{account_id}/{name}',
        CANCEL_ALL_EMAILS: 'email-steps/cancel-all/{account_id}',
        CLEAR_ANALYTICS_DATA: 'analytics/clear-data',
        DELETE_PRODUCT_COSTS_V2: 'product-costs-v2/delete/{account_id}/{id}'
    },
    [FetchMethod.PATCH]: {
        PATCH_EMAIL_STEPS: 'email-step/update-all',
        // Phase 5 web push.
        UPDATE_NOTIFICATION_CHANNELS: 'notification/{notification_id}/channels'
    }
};

export function createParamUrl(url: string, params: Record<string, string | undefined | null>) {
    for (const [key, value] of Object.entries(params)) {
        if (!value) url = url.replace(`/{${key}}`, '/');
        else url = url.replace(`{${key}}`, value);
    }
    return url;
}
